// extracted by mini-css-extract-plugin
export default {"root":"pRGtWE","link":"Tp7c0d"};